interface IParams {
  isAvailable: boolean;
  isCompulsory: boolean;
  isPaid: boolean;
}

export const isCalltrackingEnabled = (params: IParams): boolean => {
  const { isAvailable, isCompulsory, isPaid } = params;

  return isAvailable && (isCompulsory || isPaid);
};
